import { render, staticRenderFns } from "./StarRatingSettings.vue?vue&type=template&id=64001e26&scoped=true"
import script from "./StarRatingSettings.vue?vue&type=script&lang=js"
export * from "./StarRatingSettings.vue?vue&type=script&lang=js"
import style0 from "./StarRatingSettings.vue?vue&type=style&index=0&id=64001e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001e26",
  null
  
)

export default component.exports